// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__8peg6","checkboxIcon":"Checkbox_checkboxIcon__OANpv"};